import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-alerrt-dialog',
  standalone: true,
  imports: [MatDialogModule, MatDialogClose, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './alert-dialog.component.html',
})
export class AlertDialogComponent {

  message: string = "";
  title: string = "Alert";
  cancelButtonText = "Close";
  confirmButtonText = "OK";
  showConfirm: boolean = false;
  hideActions: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    public dialog: MatDialog) {
    if (data) {
      this.message = data.message || this.message;
      this.title = data.title || this.title;
      this.showConfirm = data.showConfirm ?? false;
      this.hideActions = data.hideActions ?? false;
      if (data.buttonText) {
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        this.confirmButtonText = data.buttonText.confirm || this.confirmButtonText;
      }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}
